import {DEFAULT_FONT_SIZE, SIGNIFICANT_DIGIT_RECIPROCAL} from '../constant';

/**
 * 폰트 사이즈 퍼센트를 구하는 함수입니다.
 *
 * 1 ~ 9단계(fontSizeLevel)이며, 5단계가 body 20px(DEFAULT_FONT_SIZE)를 기준으로 한 기본값입니다.
 * 5단계를 100%로 두고 퍼센트를 계산합니다.
 */
export function getTextViewerFontSizePercent(fontSizeLevel: number) {
  const fontSizeLevelIndex = Math.max(
    Math.min(fontSizeLevel - 1, FONT_SIZE_LIST.length),
    0
  );
  return (
    Math.round(
      (FONT_SIZE_LIST[fontSizeLevelIndex] / DEFAULT_FONT_SIZE) *
        100 *
        SIGNIFICANT_DIGIT_RECIPROCAL
    ) / SIGNIFICANT_DIGIT_RECIPROCAL
  );
}

const FONT_SIZE_LIST = [12, 14, 16, 18, 20, 22, 24, 26, 28];
